import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonModal from "Components/CommonModal";
import { catchError } from "JS/common";
import { updatePrice } from "JS/API";
import { designTokens, commonStyles } from "utils/designSystem";
import {
    FaTimes,
    FaCreditCard,
    FaEdit,
    FaDollarSign,
    FaPercent,
} from "react-icons/fa";
import { detailModalStyles } from "utils/modalDesignSystem";

const PaymentEditModal = ({ setPayEditModal, onSuccess, editData, setEditData, id }) => {
    const [alert, setAlert] = useState("");
    const [alertBox, setAlertBox] = useState({
        mode: "",
        context: "",
        bool: false,
    });
    const navigate = useNavigate();

    const [paymentAmount, setPaymentAmount] = useState('');
    const formatNumber = (value) =>
        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const [surTax, setSurTax] = useState('');
    const [, setDueDate] = useState('');

    const [isSurTaxEdited, setIsSurTaxEdited] = useState(false);

    useEffect(() => {
        if (editData) {
            setPaymentAmount(String(editData.merchant_price || ''));
            setDueDate(editData.ended_at?.split('T')[0] || '');
            setSurTax(String(editData.merchant_vat ?? ''));
            setIsSurTaxEdited(true);
        } else {
            const today = new Date();
            const nextWeek = new Date(today.setDate(today.getDate() + 7));
            const isoString = nextWeek.toISOString().split("T")[0];
            setDueDate(isoString);
        }
    }, [editData]);


    useEffect(() => {
        if (!editData && !isNaN(paymentAmount) && paymentAmount !== '' && !isSurTaxEdited) {
            const amount = parseInt(paymentAmount, 10);
            setSurTax(Math.floor(amount * 0.1).toString());
        }
    }, [paymentAmount, isSurTaxEdited]);




    const handleEdit = async () => {
        if (!paymentAmount || !surTax) {
            setAlertBox({
                mode: "alert",
                context: "항목을 모두 입력해주세요.",
                bool: true,
            });
            return;
        }

        try {
            const payload = {
                payment_pk: id,
                update_merchant_price: Number(paymentAmount),
                update_merchant_vat: Number(surTax)
            };

            await updatePrice(payload);
            onSuccess()
            setAlert("closeModal");
            setAlertBox({
                mode: "alert",
                context: "결제 정보가 수정되었습니다.",
                bool: true,
            });

        } catch (error) {
            catchError(error, navigate, setAlertBox, setAlert);
        }
    };

    const modalStyles = {
        overlay: detailModalStyles.overlay,
        container: {
            backgroundColor: designTokens.colors.surface,
            borderRadius: designTokens.borderRadius.xl,
            boxShadow: designTokens.shadows.lg,
            width: '100%',
            maxWidth: '500px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        header: detailModalStyles.header,
        title: detailModalStyles.title,
        closeButton: detailModalStyles.closeButton,
        content: detailModalStyles.content,
        mainContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: designTokens.spacing.xxl,
        },
        formField: detailModalStyles.formField,
        formLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: designTokens.spacing.sm,
            fontSize: '14px',
            fontWeight: '600',
            color: designTokens.colors.text.primary
        },
        formInput: {
            ...commonStyles.input
        },
        actionButtons: detailModalStyles.actionButtons,
        primaryButton: detailModalStyles.primaryButton,
        secondaryButton: detailModalStyles.secondaryButton}

    return (
        <>
            <div style={modalStyles.overlay}>
                <div style={modalStyles.container} >
                    <div style={modalStyles.header}>
                        <h3 style={modalStyles.title}>
                            <FaCreditCard />
                            결제 금액 수정
                        </h3>
                        <button
                            style={modalStyles.closeButton} onClick={() => {
                                setPayEditModal(false)
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = designTokens.colors.background;
                                e.target.style.color = designTokens.colors.text.primary;
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = designTokens.colors.text.tertiary;
                            }}
                        >
                            <FaTimes size={16} />
                        </button>
                    </div>
                    <div style={modalStyles.content}>
                        <div style={modalStyles.mainContent}>
                            <div style={modalStyles.formField}>
                                <label style={modalStyles.formLabel}>
                                    <FaDollarSign />
                                    결제 금액
                                </label>
                                <input
                                    style={modalStyles.formInput}
                                    placeholder="ex) 100,000"
                                    type="text"
                                    value={formatNumber(paymentAmount)}
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/,/g, '');
                                        if (!isNaN(rawValue)) {
                                            setPaymentAmount(rawValue);
                                        }
                                    }}
                                />
                            </div>
                            <div style={modalStyles.formField}>
                                <label style={modalStyles.formLabel}>
                                    <FaPercent />
                                    부가세
                                </label>
                                <input
                                    placeholder="자동 계산 또는 직접 입력"
                                    type="text"
                                    style={modalStyles.formInput}
                                    value={surTax !== '' ? formatNumber(surTax) : ''}
                                    onChange={(e) => {
                                        const rawValue = e.target.value.replace(/,/g, '');
                                        if (!isNaN(rawValue)) {
                                            setSurTax(rawValue);
                                            setIsSurTaxEdited(true);
                                        }
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div style={modalStyles.actionButtons}>
                        <button
                            style={modalStyles.primaryButton}
                            onClick={handleEdit}>
                            <FaEdit size={12}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = designTokens.colors.primaryHover || '#2563eb';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = designTokens.colors.primary;
                                }} 
                                />
                            수정
                        </button>
                        <button
                            style={modalStyles.secondaryButton}
                            onClick={() => {
                                setPayEditModal(false)
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = designTokens.colors.background;
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = designTokens.colors.surface;
                            }}
                        >
                            취소</button>
                    </div>
                </div>
            </div >
            {
                alertBox.bool && (
                    <CommonModal
                        setModal={setAlertBox}
                        modal={alertBox}
                        okFn={() => {
                            if (alert === "closeModal") setPayEditModal(false);
                            if (alert === "logout") navigate("/");
                        }}
                    />
                )
            }

        </>
    );
};

export default PaymentEditModal;
